export * from './notFound.component';
